import React from 'react';
import { Text } from '@chakra-ui/react';

interface InstallmentTextProps {
    maxInstallments?: number;
}

export const InstallmentText: React.FC<InstallmentTextProps> = ({
    maxInstallments = 12 // fallback para 12 parcelas quando não houver valor
}) => {
    return (
        <Text fontSize="sm" color="green.500">
            {maxInstallments === 1
                ? 'Verificado'
                : `Parcele em até ${maxInstallments}x`}
        </Text>
    );
};